import { FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ControlledTextField, ControlledTextFieldProps } from "./ControlledTextField";

export const CompanyNameField = <T extends FieldValues>({
  rules,
  inputProps,
  ...props
}: ControlledTextFieldProps<T>) => {
  const { t } = useTranslation();

  const ariaLabel = t("common.labels.company_name");

  return (
    <ControlledTextField
      rules={{
        required: {
          value: true,
          message: t("common.errors.required_field")
        },
        maxLength: {
          value: 300,
          message: t("common.errors.max_length", { count: 300 })
        },
        ...rules
      }}
      placeholder={ariaLabel}
      inputProps={{ maxLength: 300, "aria-label": ariaLabel, ...inputProps }}
      defaultIsValid
      {...props}
    />
  );
};
